import React from 'react';
import PropTypes from 'prop-types';
import { CallupHead, WxLaunchHack } from 'ThreeTerminal_mobile_dynamic';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Header extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        keyword: PropTypes.array,
        subid: PropTypes.string,
        isCallClientLiveVideo: PropTypes.bool,
        liveId: PropTypes.string,
    };

    render() {
        const { id, keyword, subid, isCallClientLiveVideo, liveId } = this.props;
        const subidVal = subid ? `&subid=${subid}` : '';
        const downloads = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
        };

        const headData = {
            pageInfo: {
                type: 'survey',
                url: location.href,
                id: `${id}`,
                // id: `https://nine.ifeng.com/surveydetail?sid=${id}`,
                downloads,
            },
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                ref: `survey_${id}`,
                kind: 'survey',
                callupKind: 'share01',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                ref: `survey_${id}`,
                kind: 'survey',
                callupKind: 'share01',
            },
            hotKeyword: keyword,
        };

        const wxLaunchHackData = {
            callAppConfig: {
                docType: 'web',
                pid: `https://flive.ifeng.com/live/${liveId}.html?isFull=1&webkit=1&immersion=true&needpage=1`,
                kind: 'inter_splh02',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7248753076782225408',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9152',
            },
            statisticsConfig: {
                behavior: 'action',
                type: 'livesurvey02',
            },
        };

        return (
            <div className={styles.callClientLiveBox}>
                <CallupHead content={headData} />
                {isCallClientLiveVideo && (
                    <div className={styles.callClientLive}>
                        <WxLaunchHack content={wxLaunchHackData} />
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(Header);
